import { render, staticRenderFns } from "./ApplicantInfoComponent.vue?vue&type=template&id=1a472ffa&scoped=true"
import script from "./ApplicantInfoComponent.vue?vue&type=script&lang=js"
export * from "./ApplicantInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./ApplicantInfoComponent.vue?vue&type=style&index=0&id=1a472ffa&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a472ffa",
  null
  
)

export default component.exports